<div class="reveal-overlay tpiq-reveal" (click)="hideReveal()">
</div>
<div class="reveal tax-strategy-reveal tpiq-reveal"  style="width: 45%;">
  <div style="height: 50px; padding: 15px; color: #333333;">
    <span class="float-left">Build Your Own Formula</span>
    <span class="float-right pointer" (click)="hideReveal()">X</span>
  </div>
  <div style="padding: 0 15px;">
    <hr style="margin: 0;"/>
  </div>
  <div class="body reveal-publish" style="padding: 15px;">
    <div class="row row-padding-reveal">
      <div class="small-12 medium-12">
        <label>
          Rate Name
          <input type="text" placeholder="Enter Custom Rate Name" [(ngModel)]="tempCustomRateObject.name"/>
        </label>
      </div>
      <div class="small-12 medium-7">
        <input style="margin-bottom: 0;" type="text" [disabled]="true" [(ngModel)]="finalFormula.displayValue"/>
        <div style="color: #667085;font-size: 12px;">*Enter in 20% as 20</div>
        <div *ngIf="finalFormula.displayValue && formulaValid" style="color: #14B5F0;"><span>Formula is valid</span></div>
        <div *ngIf="finalFormula.displayValue && !formulaValid" style="color: #F06459;"><span>Formula is invalid</span></div>
      </div>
      <div class="small-12 medium-5">
        <div class="row">
          <div class="small-12 medium-6 columns">
            <button class="small button formula-button-color" (click)="updateFormula('back')">Back</button>
          </div>
          <div class="small-12 medium-6 columns">
            <button class="small button formula-button-color" (click)="updateFormula('clear')">AC</button>
          </div>
        </div>
      </div>
      <div class="medium-12"><hr style="margin: 10px 0 10px 0 !important;"/></div>
    </div>
    <div class="row row-padding-reveal">
      <div class="small-12 medium-8">
        <div class="row">
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('7')">7</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('8')">8</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('9')">9</button>

          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color" (click)="updateFormula('*')">X</button>
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('4')">4</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('5')">5</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('6')">6</button>

          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color" (click)="updateFormula('-')">-</button>
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('1')">1</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('2')">2</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('3')">3</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color" (click)="updateFormula('+')">+</button>
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-3">
            <button class="small button formula-button-color formula-number" (click)="updateFormula('0')">0</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color" style="font-weight: bold;" (click)="updateFormula('.')">.</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color" (click)="updateFormula('%')">%</button>
          </div>
          <div class="small-12 medium-3">
            <button class="small button formula-button-color" (click)="updateFormula('/')">/</button>
          </div>
        </div>
      </div>
      <div class="small-12 medium-4">
        <div class="row">
          <div class="small-12 medium-12" *ngFor="let rate of fixedRatesArray;let i = index">
            <button class="small button formula-button-color" (click)="updateFormula(rate, 'rates')">{{rate.name}}</button>
          </div>
        </div>
      </div>
      <div class="small-12 medium-12" *ngIf="sampleCalculatedTaxValue && formulaValid">
        <span style="color: #475467;font-size: 13px;">Applying above formula on <span style="color: #1570EF !important;">$1000</span> tax savings will be: <span  style="color: #1570EF !important;">{{sampleCalculatedTaxValue | formatAmount:'$0,0'}}</span></span>
      </div>
      <div class="small-12 medium-12">
        <button class="button small float-right" (click)="createOrUpdateCustomRate()">{{isCustomRateEdit ? "Update" : "Add"}}</button>
        <button class="button small float-right cancel-button" (click)="hideReveal()">Cancel</button>
      </div>
    </div>
  </div>
</div>
